export const editorMode = [
  'object', //
  'material',
  'scene',
  'live',
];
